<template>
  <b-modal id="cart-promotion-code" title="Kortingscode" hide-footer>
    <template v-if="loading">
      <div class="spinner-border text-primary mx-auto d-block" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </template>
    <template v-else>
      <div class="form-group">
        <bs-input label="Vul hier je code in" name="code" v-model="code" placeholder="Kortingscode"></bs-input>
        <div v-if="message" class="d-block invalid-feedback animated fadeIn">{{ message | capitalize }}</div>
      </div>
      <button class="btn btn-primary btn-block btn-lg" v-on:click.prevent="applyCode">
        Toevoegen
      </button>
    </template>
  </b-modal>
</template>
<script>
import EventBus from '../plugins/vue-event-bus';

export default {
  data() {
    return {
      loading: false,
      message: null,
      code: null,
    };
  },
  watch: {
    code() {
      this.message = null;
    }
  },
  methods: {
    applyCode() {
      this.loading = true;
      axios
        .post(route('cart.applyPromocode'), {
          code: this.code,
        })
        .then((response) => {
          if (response.data) {
            if (response.data.success) {
              EventBus.publish('cart.refresh');
              this.$bvModal.hide('cart-promotion-code');
              this.$notify({
                group: 'main',
                type: 'success',
                title: `Kortingscode ${this.code} is toegevoegd aan de winkelwagen`,
              });
              this.code = null;
            } else if (response.data.errors) {
              this.message = response.data.errors['code'][0];
            } else if (response.data.message) {
              this.message = response.data.message;
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
